import { USER_UPGRADE_CLEAR } from '@/constants/constants';
const HYDRATE = "__NEXT_REDUX_WRAPPER_HYDRATE__";

export const types = {
  // GET_PERMISSION_TO_OPEN_A_BREAKDOWN
  GET_PERMISSION_TO_OPEN_A_BREAKDOWN: 'BREAKDOWN/GET_PERMISSION_TO_OPEN_A_BREAKDOWN',
  GET_PERMISSION_TO_OPEN_A_BREAKDOWN_SUCCESS: 'BREAKDOWN/GET_PERMISSION_TO_OPEN_A_BREAKDOWN_SUCCESS',
  GET_PERMISSION_TO_OPEN_A_BREAKDOWN_FAILURE: 'BREAKDOWN/GET_PERMISSION_TO_OPEN_A_BREAKDOWN_FAILURE',
  // GET_BREAKDOWN_REASONS
  GET_BREAKDOWN_REASONS: 'BREAKDOWN/GET_BREAKDOWN_REASONS',
  GET_BREAKDOWN_REASONS_SUCCESS: 'BREAKDOWN/GET_BREAKDOWN_SUCCESS',
  GET_BREAKDOWN_REASONS_FAILURE: 'BREAKDOWN/GET_BREAKDOWN_REASONS_FAILURE',
  // OPEN_BREAKDOWN_REASONS
  OPEN_BREAKDOWN: 'BREAKDOWN/OPEN_BREAKDOWN',
  OPEN_BREAKDOWN_SUCCESS: 'BREAKDOWN/OPEN_BREAKDOWN_SUCCESS',
  OPEN_BREAKDOWN_FAILURE: 'BREAKDOWN/OPEN_BREAKDOWN_FAILURE',
  RESET_OPEN_BREAKDOWN: 'BREAKDOWN/RESET_OPEN_BREAKDOWN',
  // BREAKDOWN_TRACKING
  BREAKDOWN_TRACKING: 'BREAKDOWN/BREAKDOWN_TRACKING',
  BREAKDOWN_TRACKING_SUCCESS: 'BREAKDOWN/BREAKDOWN_TRACKING_SUCCES',
  BREAKDOWN_TRACKING_FAILURE: 'BREAKDOWN/BREAKDOWN_TRACKING_FAILURE',
  RESET_BREAKDOWN_TRACKING: 'RESET_BREAKDOWN_TRACKING',
  // NUMBER_BREAKDOWN
  NUMBER_BREAKDOWN: 'BREAKDOWN/NUMBER_BREAKDOWN',
  NUMBER_BREAKDOWN_SUCCESS: 'BREAKDOWN/NUMBER_BREAKDOWN_SUCCES',
  NUMBER_BREAKDOWN_FAILURE: 'BREAKDOWN/NUMBER_BREAKDOWN_FAILURE',
  // STOCK_SHOP
  STOCK_SHOP: 'STOCK_SHOP',
  STOCK_SHOP_SUCCESS: 'STOCK_SHOP_SUCCESS',
  STOCK_SHOP_FAILURE: 'STOCK_SHOP_FAILURE',
  STOCK_SHOP_RESET: 'STOCK_SHOP_RESET',

}

export const actions = {
  // GET_PERMISSION_TO_OPEN_A_BREAKDOWN
  getPermissionToOpen: () => ({ type: types.GET_PERMISSION_TO_OPEN_A_BREAKDOWN }),
  successGetPermissionToOpen: data => (
    {
      type: types.GET_PERMISSION_TO_OPEN_A_BREAKDOWN_SUCCESS,
      payload: data,
    }
  ),
  failureGetPermissionToOpen: () => ({ type: types.GET_PERMISSION_TO_OPEN_A_BREAKDOWN_FAILURE }),
  // GET_BREAKDOWN_REASONS
  getBreakdownReasons: productId => ({ type: types.GET_BREAKDOWN_REASONS, productId }),
  successGetBreakdownReasons: data => ({
    type: types.GET_BREAKDOWN_REASONS_SUCCESS, payload: data,
  }),
  failureBreakdownReasons: error => ({ type: types.GET_BREAKDOWN_REASONS_FAILURE, payload: error }),
  // OPEN_BREAKDOWN_REASONS
  openBreakdown: breakdownObj => ({ type: types.OPEN_BREAKDOWN, breakdownObj }),
  successOpenBreakdown: data => ({
    type: types.OPEN_BREAKDOWN_SUCCESS, payload: data,
  }),
  failureOpenBreak: error => ({ type: types.OPEN_BREAKDOWN_FAILURE, payload: error }),
  resetOpenbreakdown: () => ({ type: types.RESET_OPEN_BREAKDOWN }),
  // BREAKDOWN_TRACKING
  getBreakdownTracking: lastYear => ({ type: types.BREAKDOWN_TRACKING, lastYear }),
  successTrackingBreakdown: data => ({
    type: types.BREAKDOWN_TRACKING_SUCCESS, payload: data,
  }),
  failureTrackingBreakdown: error => ({ type: types.BREAKDOWN_TRACKING_FAILURE, payload: error }),
  resetTrackingBreakdown: () => ({ type: types.RESET_BREAKDOWN_TRACKING }),
  // NUMBER_BREAKDOWN
  getNumberBreakdown: () => ({ type: types.NUMBER_BREAKDOWN }),
  successNumberBreakdown: data => ({
    type: types.NUMBER_BREAKDOWN_SUCCESS, payload: data,
  }),
  failureNumberBreakdown: error => ({ type: types.NUMBER_BREAKDOWN_FAILURE, payload: error }),

  // STOCK_SHOP
  getStockShop: data => ({ type: types.STOCK_SHOP, data }),
  successGetStockShop: data => ({ type: types.STOCK_SHOP_SUCCESS, payload: data }),
  failureStockShop: error => ({ type: types.STOCK_SHOP_FAILURE, payload: error }),
  resetStockShop: () => ({ type: types.STOCK_SHOP_RESET }),
}

export const initialState = {
  // GET_PERMISSION_TO_OPEN_A_BREAKDOWN
  permissionToOpen: null,
  permissionToOpenError: false,
  permissionToOpenFetching: false,
  // GET_BREAKDOWN_REASONS
  breakdownReasons: null,
  breakdownReasonsError: false,
  breakdownReasonsFetching: false,
  // OPEN_BREAKDOWN_REASONS
  lastOpenedBreakdown: null,
  lastOpenedBreakdownError: false,
  lastOpenedBreakdownFetching: false,
  // BREAKDOWN_TRACKING
  trackingBreakdown: null,
  trackBreakdownError: false,
  trackingBreakdownFetching: false,
  // NUMBER_BREAKDOWN
  numberBreakdown: null,
  numberBreakdownError: false,
  numberBreakdownFetching: false,
  // STOCK_SHOP
  stockShop: null,
  stockShopError: false,
  stockShopFetching: false,
}

function reducer(state = { ...initialState }, { type, payload }) {
  switch (type) {
    case HYDRATE: {
      const { breakdown } = payload;
      return {
        ...state,
        ...breakdown,
      };
    }
    case USER_UPGRADE_CLEAR:
      return initialState;
    // GET_PERMISSION_TO_OPEN_A_BREAKDOWN
    case types.GET_PERMISSION_TO_OPEN_A_BREAKDOWN:
      return {
        ...state,
        permissionToOpenFetching: true,
        permissionToOpenError: false,
      }
    case types.GET_PERMISSION_TO_OPEN_A_BREAKDOWN_FAILURE:
      return {
        ...state,
        permissionToOpen: -1,
        permissionToOpenFetching: false,
        permissionToOpenError: false,
      }
    case types.GET_PERMISSION_TO_OPEN_A_BREAKDOWN_SUCCESS: {
      const permitted = payload;
      return {
        ...state,
        permissionToOpen: permitted ? 1 : -1,
        permissionToOpenFetching: false,
        permissionToOpenError: false,
      }
    }
    // GET_BREAKDOWN_REASONS
    case types.GET_BREAKDOWN_REASONS:
      return { ...state, breakdownReasonsFetching: true, breakdownReasonsError: false };
    case types.GET_BREAKDOWN_REASONS_SUCCESS: {
      const reasons = payload;
      const previousReasons = (state.breakdownReasons) ? state.breakdownReasons : {};
      return {
        ...state,
        breakdownReasons: {
          ...previousReasons,
          ...reasons,
        },
        breakdownReasonsFetching: false,
        breakdownReasonsError: false,
      };
    }
    case types.GET_BREAKDOWN_REASONS_FAILURE:
      return {
        ...state,
        breakdownReasons: null,
        breakdownReasonsError: true,
        breakdownReasonsFetching: false,
      };
    // OPEN_BREAKDOWN_REASONS
    case types.OPEN_BREAKDOWN:
      return { ...state, lastOpenedBreakdownFetching: true };
    case types.OPEN_BREAKDOWN_SUCCESS:
      return {
        ...state,
        lastOpenedBreakdown: payload,
      }
    case types.OPEN_BREAKDOWN_FAILURE:
      return { ...state, lastOpenedBreakdownError: true, lastOpenedBreakdownFetching: true };

    case types.RESET_OPEN_BREAKDOWN:
      return {
        ...state,
        lastOpenedBreakdown: null,
        lastOpenedBreakdownError: false,
        lastOpenedBreakdownFetching: false,
      };
      // BREAKDOWN_TRACKING
    case types.BREAKDOWN_TRACKING:
      return {
        ...state,
        trackingBreakdownFetching: true,
      }
    case types.BREAKDOWN_TRACKING_SUCCESS:
      return {
        ...state,
        trackingBreakdown: payload,
        trackingBreakdownFetching: false,
      }
    case types.BREAKDOWN_TRACKING_FAILURE:
      return {
        ...state,
        trackingBreakdown: payload,
        trackingBreakdownError: true,
        trackingBreakdownFetching: false,
      };
    case types.RESET_BREAKDOWN_TRACKING:
      return {
        ...state,
        trackingBreakdown: null,
        trackingBreakdownError: false,
        trackingBreakdownFetching: false,
      };
      // NUMBER_BREAKDOWN
    case types.NUMBER_BREAKDOWN:
      return {
        ...state,
        numberBreakdownFetching: true,
      };
    case types.NUMBER_BREAKDOWN_SUCCESS:
      return {
        ...state,
        numberBreakdown: payload,
        numberBreakdownFetching: false,
      }
    case types.NUMBER_BREAKDOWN_FAILURE:
      return {
        ...state,
        numberBreakdownError: true,
        numberBreakdownFetching: false,
      };
      // STOCK_SHOP
    case types.STOCK_SHOP:
      return {
        ...state,
        stockShop: null,
        stockShopFetching: true,
        stockShopError: false,
      }
    case types.STOCK_SHOP_SUCCESS:
      return {
        ...state,
        stockShop: payload,
        stockShopFetching: false,
        stockShopError: false,
      }
    case types.STOCK_SHOP_FAILURE:
      return {
        ...state,
        stockShop: payload,
        stockShopError: true,
        stockShopFetching: false,
      };
    case types.STOCK_SHOP_RESET:
      return {
        ...state,
        stockShop: null,
        stockShopError: false,
        stockShopFetching: false,
      };
    default:
      return state;
  }
}

export default reducer;
